import React from 'react';
import Pricing from './Pricing';

const Plans = () => {
  return <Pricing variant="trial" />;
};

export default Plans;
